const QUERY_KEYS = {
  // departments
  GET_ALL_DEPARTMENTS: "GET_ALL_DEPARTMENTS",
  GET_DEPARTMENT: "GET_DEPARTMENT",

  // users
  GET_ALL_USERS: "GET_ALL_USERS",
  GET_SINGLE_USER: "GET_SINGLE_USER",
  GET_DEPARTMENT_MANAGERS: "GET_DEPARTMENT_MANAGERS",

  // announcements
  CREATE_ANNOUNCEMENT: "CREATE_ANNOUNCEMENT",
  UPDATE_ANNOUNCEMENT: "UPDATE_ANNOUNCEMENT",
  GET_ALL_ANNOUNCEMENTS: "GET_ALL_ANNOUNCEMENTS",
  GET_ANNOUNCEMENTS_BY_IDS: "GET_ANNOUNCEMENTS_BY_IDS",
  GET_ALL_ANNOUNCEMENTS_FOR_STATS: "GET_ALL_ANNOUNCEMENTS_FOR_STATS",
  DELETE_ANNOUNCEMENT: "DELETE_ANNOUNCEMENT",
  BULK_DELETE_ANNOUNCEMENTS: "BULK_DELETE_ANNOUNCEMENTS",
  SOFT_DELETE_ANNOUNCEMENT: "SOFT_DELETE_ANNOUNCEMENT",
  GET_ALL_ANNOUNCEMENTS_BY_DATE: "GET_ALL_ANNOUNCEMENTS_BY_DATE",
  GET_BRIEF_ANNOUNCEMENTS_BY_DATE: "GET_BRIEF_ANNOUNCEMENTS_BY_DATE",
  GET_SINGLE_ANNOUNCEMENT: "GET_SINGLE_ANNOUNCEMENT",
  GET_RESERVATION_ZONES: "GET_RESERVATION_ZONES",

  // announcement tasks
  UPDATE_ANNOUNCEMENT_TASK: "UPDATE_ANNOUNCEMENT_TASK",
  DELETE_ANNOUNCEMENT_TASK: "DELETE_ANNOUNCEMENT_TASK",

  // announcement responders
  TOGGLE_ANNOUNCEMENT_RESPONDER: "TOGGLE_ANNOUNCEMENT_RESPONDER",

  // announcement tasks comments
  CREATE_ANNOUNCEMENT_TASK_COMMENT: "CREATE_ANNOUNCEMENT_TASK_COMMENT",
  UPDATE_ANNOUNCEMENT_TASK_COMMENT: "UPDATE_ANNOUNCEMENT_TASK_COMMENT",
  DELETE_ANNOUNCEMENT_TASK_COMMENT: "DELETE_ANNOUNCEMENT_TASK_COMMENT",

  // forms
  GET_ALL_FORMS: "GET_ALL_FORMS",
  GET_FORMS_BY_IDS: "GET_FORMS_BY_IDS",
  GET_FORM_WITH_ANSWERS: "GET_FORM_WITH_ANSWERS",
  GET_FORM_BY_ID: "GET_FORM_WITH_ANSWERS",
  CREATE_RESPONSE_FORM_BY_ID: "CREATE_RESPONSE_FORM_WITH_ANSWERS",

  // checklist
  GET_CHECKLIST: "GET_CHECKLIST",
  GET_ALL_CHECKLISTS: "GET_ALL_CHECKLISTS",
  GET_GROUPED_CHECKLISTS: "GET_GROUPED_CHECKLISTS",
  GET_ALL_CHECKLISTS_SHIFT_ID: "GET_ALL_CHECKLISTS_SHIFT_ID",

  // equipment
  GET_ALL_EQUIPMENTS: "GET_ALL_EQUIPMENTS",

  // clients
  GET_ALL_CLIENTS: "GET_ALL_CLIENTS",
  GET_USER_CLIENT: "GET_USER_CLIENT",

  // branches
  GET_BRANCHES_BY_CLIENT: "GET_BRANCHES_BY_CLIENT",

  // role
  GET_ALL_ROLES: "GET_ALL_ROLES",
  GET_GROUPED_ROLES: "GET_GROUPED_ROLES",
  GET_SINGLE_ROLE: "GET_SINGLE_ROLE",

  // user group
  GET_ALL_USER_GROUPS: "GET_ALL_USER_GROUPS",
  GET_SINGLE_USER_GROUP: "GET_SINGLE_USER_GROUP",

  // role types
  GET_ALL_ROLE_TYPES: "GET_ALL_ROLE_TYPES",

  // on-boarding
  GET_ON_BOARDING_DRAFT: "GET_ON_BOARDING_DRAFT",
  GET_ADMIN_ON_BOARDING_DRAFTS: "GET_ADMIN_ON_BOARDING_DRAFTS",
  DELETE_ADMIN_ON_BOARDING_DRAFT: "DELETE_ADMIN_ON_BOARDING_DRAFT",
  ARCHIVE_ADMIN_LOCATION: "ARCHIVE_ADMIN_LOCATION",
  CHECK_EMAILS_EXIST: "CHECK_EMAILS_EXIST",

  // permissions
  GET_ALL_GROUPED_PERMISSIONS: "GET_ALL_GROUPED_PERMISSIONS",
  GET_PERMISSION_TREE: "GET_PERMISSION_TREE",

  // shifts
  GET_ALL_SHIFTS: "GET_ALL_SHIFTS",

  // day summary
  GET_DAY_SUMMARY: "GET_DAY_SUMMARY",
  GET_DAY_SUMMARY_STATUS: "GET_DAY_SUMMARY_STATUS",
  ACKNOWLEDGE_DAY_SUMMARY: "ACKNOWLEDGE_DAY_SUMMARY",

  //notifications

  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
  DELETE_SELECTED_NOTIFICATIONS: "DELETE_SELECTED_NOTIFICATIONS",
  MARK_ALL_NOTIFICATIONS_AS_READ: "MARK_ALL_NOTIFICATIONS_AS_READ",
};

export default QUERY_KEYS;
